/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const LineHeightIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Line Height',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m4.96973,13.96973l-.46973.46973V5.06055l.46973.46973c.14648.14648.33789.21973.53027.21973s.38379-.07324.53027-.21973c.29297-.29297.29297-.76758,0-1.06055l-1.75-1.75c-.29297-.29297-.76758-.29297-1.06055,0l-1.75,1.75c-.29297.29297-.29297.76758,0,1.06055s.76758.29297,1.06055,0l.46973-.46973v9.37891l-.46973-.46973c-.29297-.29297-.76758-.29297-1.06055,0s-.29297.76758,0,1.06055l1.75,1.75c.06909.06909.15186.12354.24341.16162s.18896.05811.28687.05811.19531-.02002.28687-.05811.17432-.09253.24341-.16162l1.75-1.75c.29297-.29297.29297-.76758,0-1.06055s-.76758-.29297-1.06055,0Z"
      fill="currentColor"
    />
    <path
      d="m17.25,4.5h-7.5c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h7.5c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="m17.25,10.5h-7.5c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h7.5c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
    <path
      d="m17.25,16.5h-7.5c-.41406,0-.75-.33594-.75-.75s.33594-.75.75-.75h7.5c.41406,0,.75.33594.75.75s-.33594.75-.75.75Z"
      fill="currentColor"
    />
  </svg>`;
};
